// removed by extract-text-webpack-plugin
module.exports = {"image":"AccountTransferDisabledModal__image___2Yw-L"};


//////////////////
// WEBPACK FOOTER
// ./src/payments/components/styles/AccountTransferDisabledModal.css
// module id = 2741
// module chunks = 0 1